export interface ProjectProps {
    title: string;
    thumbnail: string;
    link: string;
    name: string;
    description: string;
    images: ImageProps[];
    projectNumber?: string;
    nextLink?: string;
}

interface ImageProps {
    thumbnail: string;
    original: string;
}

export const PROJECTS: ProjectProps[] = [
    {
        title: '<h2>The Reef<br/>Island Resort</h2>',
        name: 'The Reef Island Resort',
        thumbnail: '/images/projects/project-1-thumbnail.png',
        link: '/projects/the-reef-island-resort',
        description:
            '<p class="mb-4 md:mb-8">Designed in harmony with nature, the Reef Island Resort rises above the beautiful shores of Mactan and offers unique experiences to all in the embrace of the elements.</p><p>Local craftsmanship and materials are carefully brought together within the interiors to reflect the Philippines’ splendor in a resort hotel setting surrounded by a captivating coastal horizon.</p>',
        images: [
            {
                original: '/images/projects/01/001.jpg',
                thumbnail: '/images/projects/01/thumbnail/001.jpg',
            },
            {
                original: '/images/projects/01/002a.jpg',
                thumbnail: '/images/projects/01/thumbnail/002a.jpg',
            },
            {
                original: '/images/projects/01/003.jpg',
                thumbnail: '/images/projects/01/thumbnail/003.jpg',
            },
            {
                original: '/images/projects/01/004.jpg',
                thumbnail: '/images/projects/01/thumbnail/004.jpg',
            },
            {
                original: '/images/projects/01/005.jpg',
                thumbnail: '/images/projects/01/thumbnail/005.jpg',
            },
            {
                original: '/images/projects/01/006.jpg',
                thumbnail: '/images/projects/01/thumbnail/006.jpg',
            },
            {
                original: '/images/projects/01/007.jpg',
                thumbnail: '/images/projects/01/thumbnail/007.jpg',
            },
            {
                original: '/images/projects/01/008.jpg',
                thumbnail: '/images/projects/01/thumbnail/008.jpg',
            },
            {
                original: '/images/projects/01/009.jpg',
                thumbnail: '/images/projects/01/thumbnail/009.jpg',
            },
            {
                original: '/images/projects/01/010.jpg',
                thumbnail: '/images/projects/01/thumbnail/010.jpg',
            },
            {
                original: '/images/projects/01/011.jpg',
                thumbnail: '/images/projects/01/thumbnail/011.jpg',
            },
            {
                original: '/images/projects/01/012.jpg',
                thumbnail: '/images/projects/01/thumbnail/012.jpg',
            },
            {
                original: '/images/projects/01/013.jpg',
                thumbnail: '/images/projects/01/thumbnail/013.jpg',
            },
            {
                original: '/images/projects/01/014.jpg',
                thumbnail: '/images/projects/01/thumbnail/014.jpg',
            },
            {
                original: '/images/projects/01/015.jpg',
                thumbnail: '/images/projects/01/thumbnail/015.jpg',
            },
            {
                original: '/images/projects/01/016.jpg',
                thumbnail: '/images/projects/01/thumbnail/017.jpg',
            },
            {
                original: '/images/projects/01/017.jpg',
                thumbnail: '/images/projects/01/thumbnail/017.jpg',
            },
            {
                original: '/images/projects/01/018.jpg',
                thumbnail: '/images/projects/01/thumbnail/018.jpg',
            },
            {
                original: '/images/projects/01/019.jpg',
                thumbnail: '/images/projects/01/thumbnail/019.jpg',
            },
            {
                original: '/images/projects/01/020.jpg',
                thumbnail: '/images/projects/01/thumbnail/020.jpg',
            },
            {
                original: '/images/projects/01/022.jpg',
                thumbnail: '/images/projects/01/thumbnail/022.jpg',
            },
            {
                original: '/images/projects/01/023.jpg',
                thumbnail: '/images/projects/01/thumbnail/023.jpg',
            },
            {
                original: '/images/projects/01/024.jpg',
                thumbnail: '/images/projects/01/thumbnail/024.jpg',
            },
            {
                original: '/images/projects/01/025.jpg',
                thumbnail: '/images/projects/01/thumbnail/025.jpg',
            },
        ],
    },
    {
        title: 'Isla Camungi',
        name: 'Isla Camungi',
        thumbnail: '/images/projects/project-2-thumbnail.png',
        link: '/projects/isla-camungi',
        description:
            '<p class="mb-4 md:mb-8">For travellers seeking a truly isolated tropical getaway, Isla Camungi is an exclusive private island inside a protected migratory bird and marine sanctuary.</p><p> On one side, tropical wetlands that remain untouched by time can be explored through guided mangrove trails and on the other, empty white sand beaches have been planned with minimally-intrusive structures of indigenous material and locally-made bamboo furniture.</p>',
        images: [
            {
                original: '/images/projects/02/1b.jpg',
                thumbnail: '/images/projects/02/thumbnail/1b.jpg',
            },
            {
                original: '/images/projects/02/2a.jpg',
                thumbnail: '/images/projects/02/thumbnail/2a.jpg',
            },
            {
                original: '/images/projects/02/3a.jpg',
                thumbnail: '/images/projects/02/thumbnail/3a.jpg',
            },
            {
                original: '/images/projects/02/4b.jpg',
                thumbnail: '/images/projects/02/thumbnail/4b.jpg',
            },
            {
                original: '/images/projects/02/5.jpg',
                thumbnail: '/images/projects/02/thumbnail/5.jpg',
            },
        ],
    },
    {
        title: 'L Residence',
        name: 'L Residence',
        thumbnail: '/images/projects/project-3-thumbnail.png',
        link: '/projects/l-residence',
        description:
            '<p class="mb-4 md:mb-8">Atop a hillcrest in the village of Pristina North, this residence was built for a couple by their son with generous open spaces and multiple bedrooms to invite their family to gather frequently. The architecture is softened by a light palette of colors; inside, the finest Italian finishes and furnishings have been painstakingly put together with perfection in mind.</p>',
        images: [
            {
                original: '/images/projects/03/001.jpg',
                thumbnail: '/images/projects/03/thumbnail/001.jpg',
            },
            {
                original: '/images/projects/03/002.jpg',
                thumbnail: '/images/projects/03/thumbnail/002.jpg',
            },
            {
                original: '/images/projects/03/003.jpg',
                thumbnail: '/images/projects/03/thumbnail/003.jpg',
            },
            {
                original: '/images/projects/03/004.jpg',
                thumbnail: '/images/projects/03/thumbnail/004.jpg',
            },
            {
                original: '/images/projects/03/005.jpg',
                thumbnail: '/images/projects/03/thumbnail/005.jpg',
            },
            {
                original: '/images/projects/03/006.jpg',
                thumbnail: '/images/projects/03/thumbnail/006.jpg',
            },
            {
                original: '/images/projects/03/007.jpg',
                thumbnail: '/images/projects/03/thumbnail/007.jpg',
            },
        ],
    },
    {
        title: 'L1 Resort Suite at the Reef',
        name: 'L1 Resort Suite at the Reef',
        thumbnail: '/images/projects/project-4-thumbnail.png',
        link: '/projects/l1-resort-suite-at-the-reef',
        description:
            '<p>Initially an apartment that wasn’t of significance, once completed the owner now deliberately resides here when he’s in town, adjusting his schedule to do so.</p><p>With a stunning panorama of the ocean visible from all its key areas—both bedrooms and the living-dining-kitchen studio, it’s designed for a young family to comfortably live and have a few (or fifteen!) guests over to share the view.</p>',
        images: [
            {
                original: '/images/projects/04/001.jpg',
                thumbnail: '/images/projects/04/thumbnail/001.jpg',
            },
            {
                original: '/images/projects/04/002.jpg',
                thumbnail: '/images/projects/04/thumbnail/002.jpg',
            },
            {
                original: '/images/projects/04/003.jpg',
                thumbnail: '/images/projects/04/thumbnail/003.jpg',
            },
            {
                original: '/images/projects/04/004.jpg',
                thumbnail: '/images/projects/04/thumbnail/004.jpg',
            },
            {
                original: '/images/projects/04/005.jpg',
                thumbnail: '/images/projects/04/thumbnail/005.jpg',
            },
            {
                original: '/images/projects/04/006.jpg',
                thumbnail: '/images/projects/04/thumbnail/006.jpg',
            },
            {
                original: '/images/projects/04/007.jpg',
                thumbnail: '/images/projects/04/thumbnail/007.jpg',
            },
            {
                original: '/images/projects/04/008.jpg',
                thumbnail: '/images/projects/04/thumbnail/008.jpg',
            },
        ],
    },
    {
        title: 'Resort Suite at Movenpick',
        name: 'Resort Suite at Movenpick',
        thumbnail: '/images/projects/project-5-thumbnail.png',
        link: '/projects/resort-suite-at-movenpick',
        description:
            '<p class="mb-4 md:mb-8">This is a residential unit in a resort that needs an update. After having lived here ourselves we had a few ideas on how to temper the overall interiors—keeping the playful, easy spirit of living by the beach while introducing some much needed improvements. Depending on how the apartment would be used in the future, two layout options were presented and are documented here.</p>',
        images: [
            {
                original: '/images/projects/05/001.jpg',
                thumbnail: '/images/projects/05/thumbnail/001.jpg',
            },
            {
                original: '/images/projects/05/002.jpg',
                thumbnail: '/images/projects/05/thumbnail/002.jpg',
            },
            {
                original: '/images/projects/05/003.jpg',
                thumbnail: '/images/projects/05/thumbnail/003.jpg',
            },
            {
                original: '/images/projects/05/004.jpg',
                thumbnail: '/images/projects/05/thumbnail/004.jpg',
            },
            {
                original: '/images/projects/05/005.jpg',
                thumbnail: '/images/projects/05/thumbnail/005.jpg',
            },
            {
                original: '/images/projects/05/006.jpg',
                thumbnail: '/images/projects/05/thumbnail/006.jpg',
            },
            {
                original: '/images/projects/05/007.jpg',
                thumbnail: '/images/projects/05/thumbnail/007.jpg',
            },
            {
                original: '/images/projects/05/008.jpg',
                thumbnail: '/images/projects/05/thumbnail/008.jpg',
            },
            {
                original: '/images/projects/05/009.jpg',
                thumbnail: '/images/projects/05/thumbnail/009.jpg',
            },
        ],
    },
    {
        title: 'MMA Pilates Studio',
        name: 'MMA Pilates Studio',
        thumbnail: '/images/projects/project-6-thumbnail.png',
        link: '/projects/mma-pilates-studio',
        description:
            '<p class="mb-4 md:mb-8">Designed for a Pilates studio in Alabang, mirrors were used to depict infinite horizontals from both the floor and ceiling, giving the illusion of a stretching expanse. The ceiling panels are also detailed with a cascading angle, giving a theatrical feeling to the space and inviting clients to perform their exercise routines with confidence.</p>',
        images: [
            {
                original: '/images/projects/06/001.jpg',
                thumbnail: '/images/projects/06/thumbnail/001.jpg',
            },
            {
                original: '/images/projects/06/002.jpg',
                thumbnail: '/images/projects/06/thumbnail/002.jpg',
            },
            {
                original: '/images/projects/06/003.jpg',
                thumbnail: '/images/projects/06/thumbnail/003.jpg',
            },
            {
                original: '/images/projects/06/004.jpg',
                thumbnail: '/images/projects/06/thumbnail/004.jpg',
            },
            {
                original: '/images/projects/06/005.jpg',
                thumbnail: '/images/projects/06/thumbnail/005.jpg',
            },
        ],
    },
    {
        title: 'Y Residence',
        name: 'Y Residence',
        thumbnail: '/images/projects/project-7-thumbnail.png',
        link: '/projects/y-residence',
        description:
            '<p class="mb-4 md:mb-8">With a young couple starting their life together in mind, the ideal is that they would be settling into their dream house once all the work is done. Laidback and with a love to entertain guests, our vision for their interiors is of effortless flow, everyday comfort, and easy maintenance.</p>',
        images: [
            {
                original: '/images/projects/07/000.jpg',
                thumbnail: '/images/projects/07/thumbnail/000.jpg',
            },
            {
                original: '/images/projects/07/001.jpg',
                thumbnail: '/images/projects/07/thumbnail/001.jpg',
            },
            {
                original: '/images/projects/07/003.jpg',
                thumbnail: '/images/projects/07/thumbnail/003.jpg',
            },
            {
                original: '/images/projects/07/004.jpg',
                thumbnail: '/images/projects/07/thumbnail/004.jpg',
            },
            {
                original: '/images/projects/07/005.jpg',
                thumbnail: '/images/projects/07/thumbnail/005.jpg',
            },
            {
                original: '/images/projects/07/006.jpg',
                thumbnail: '/images/projects/07/thumbnail/006.jpg',
            },
            {
                original: '/images/projects/07/007.jpg',
                thumbnail: '/images/projects/07/thumbnail/007.jpg',
            },
            {
                original: '/images/projects/07/008.jpg',
                thumbnail: '/images/projects/07/thumbnail/008.jpg',
            },
            {
                original: '/images/projects/07/009.jpg',
                thumbnail: '/images/projects/07/thumbnail/009.jpg',
            },
            {
                original: '/images/projects/07/010.jpg',
                thumbnail: '/images/projects/07/thumbnail/010.jpg',
            },
            {
                original: '/images/projects/07/011.jpg',
                thumbnail: '/images/projects/07/thumbnail/011.jpg',
            },
            {
                original: '/images/projects/07/012.jpg',
                thumbnail: '/images/projects/07/thumbnail/012.jpg',
            },
            {
                original: '/images/projects/07/013.jpg',
                thumbnail: '/images/projects/07/thumbnail/013.jpg',
            },
            {
                original: '/images/projects/07/014.jpg',
                thumbnail: '/images/projects/07/thumbnail/014.jpg',
            },
            {
                original: '/images/projects/07/015.jpg',
                thumbnail: '/images/projects/07/thumbnail/015.jpg',
            },
            {
                original: '/images/projects/07/016.jpg',
                thumbnail: '/images/projects/07/thumbnail/017.jpg',
            },
        ],
    },
    {
        title: 'The Grounds',
        name: 'The Grounds',
        thumbnail: '/images/projects/project-8-thumbnail.png',
        link: '/projects/the-grounds',
        description:
            '<p class="mb-4 md:mb-8">To complement the resort activities in the hotel, certain outdoor amenities such as a dive bar, a beach barbecue shack, children’s playground, wall climbing and beach volleyball were planned and aggregated into one area. Structures were kept simple and finishes retained natural colors, granting harmony and focus on enjoying time outdoors.</p>',
        images: [
            {
                original: '/images/projects/08/001.jpg',
                thumbnail: '/images/projects/08/thumbnail/001.jpg',
            },
            {
                original: '/images/projects/08/002.jpg',
                thumbnail: '/images/projects/08/thumbnail/002.jpg',
            },
            {
                original: '/images/projects/08/003.jpg',
                thumbnail: '/images/projects/08/thumbnail/003.jpg',
            },
            {
                original: '/images/projects/08/004.jpg',
                thumbnail: '/images/projects/08/thumbnail/004.jpg',
            },
            {
                original: '/images/projects/08/005.jpg',
                thumbnail: '/images/projects/08/thumbnail/005.jpg',
            },
            {
                original: '/images/projects/08/006.jpg',
                thumbnail: '/images/projects/08/thumbnail/006.jpg',
            },
        ],
    },
    {
        title: 'Apartment at 32 Sanson',
        name: 'Apartment at 32 Sanson',
        thumbnail: '/images/projects/project-9-thumbnail.png',
        link: '/projects/apartment-at-32-sanson',
        description:
            '<p class="mb-4 md:mb-8">Working with the client’s transitional style was a welcome endeavor, since she was not only a dear friend but also a manufacturer of export-quality furniture and accessories. Chinoiserie, panelled cabinetry and an elegant lattice bedframe are some of the point features of this apartment amidst the other intricacies and details presented.</p>',
        images: [
            {
                original: '/images/projects/09/001.jpg',
                thumbnail: '/images/projects/09/thumbnail/001.jpg',
            },
            {
                original: '/images/projects/09/002.jpg',
                thumbnail: '/images/projects/09/thumbnail/002.jpg',
            },
            {
                original: '/images/projects/09/003.jpg',
                thumbnail: '/images/projects/09/thumbnail/003.jpg',
            },
            {
                original: '/images/projects/09/004.jpg',
                thumbnail: '/images/projects/09/thumbnail/004.jpg',
            },
            {
                original: '/images/projects/09/005.jpg',
                thumbnail: '/images/projects/09/thumbnail/005.jpg',
            },
        ],
    },
    {
        title: 'Resort Suites at Sheraton',
        name: 'Resort Suites at Sheraton',
        thumbnail: '/images/projects/project-10-thumbnail.png',
        link: '/projects/resort-suites-at-sheraton',
        description:
            '<p class="mb-4 md:mb-8">Following a rich and earthen terracotta palette, the interiors concept is an amalgam of elements reminiscent of the locale as well as notable Italian tiles and fixtures as it is an Italian national’s home in the Philippines. In our early discussions, it is amusing to note that he was absolutely perplexed by the idea of a service kitchen.</p>',
        images: [
            {
                original: '/images/projects/10/001.jpg',
                thumbnail: '/images/projects/10/thumbnail/001.jpg',
            },
            {
                original: '/images/projects/10/002.jpg',
                thumbnail: '/images/projects/10/thumbnail/002.jpg',
            },
            {
                original: '/images/projects/10/003.jpg',
                thumbnail: '/images/projects/10/thumbnail/003.jpg',
            },
            {
                original: '/images/projects/10/004.jpg',
                thumbnail: '/images/projects/10/thumbnail/004.jpg',
            },
            {
                original: '/images/projects/10/005.jpg',
                thumbnail: '/images/projects/10/thumbnail/005.jpg',
            },
            {
                original: '/images/projects/10/006.jpg',
                thumbnail: '/images/projects/10/thumbnail/006.jpg',
            },
            {
                original: '/images/projects/10/007.jpg',
                thumbnail: '/images/projects/10/thumbnail/007.jpg',
            },
            {
                original: '/images/projects/10/008.jpg',
                thumbnail: '/images/projects/10/thumbnail/008.jpg',
            },
            {
                original: '/images/projects/10/009.jpg',
                thumbnail: '/images/projects/10/thumbnail/009.jpg',
            },
            {
                original: '/images/projects/10/010.jpg',
                thumbnail: '/images/projects/10/thumbnail/010.jpg',
            },
            {
                original: '/images/projects/10/011.jpg',
                thumbnail: '/images/projects/10/thumbnail/011.jpg',
            },
            {
                original: '/images/projects/10/012.jpg',
                thumbnail: '/images/projects/10/thumbnail/012.jpg',
            },
        ],
    },
    {
        title: 'L2 Resort Suite at the Reef',
        name: 'L2 Resort Suite at the Reef',
        thumbnail: '/images/projects/project-11-thumbnail.png',
        link: '/projects/l2-resort-suite-at-the-reef',
        description:
            '<p class="mb-4 md:mb-8">Given a serious, formal tone for the resort interiors as the client’s preference, the underlying challenge was to optimize the spaces without succumbing to a heavy mood of dark finishes. In this suite with ample balcony space and a corner view of the sea, custom furniture pieces and details were conscientiously designed by Realm and fabricated with the talents of Cebu craftspeople.</p>',
        images: [
            {
                original: '/images/projects/11/001.jpg',
                thumbnail: '/images/projects/11/thumbnail/001.jpg',
            },
            {
                original: '/images/projects/11/002.jpg',
                thumbnail: '/images/projects/11/thumbnail/002.jpg',
            },
            {
                original: '/images/projects/11/003.jpg',
                thumbnail: '/images/projects/11/thumbnail/003.jpg',
            },
            {
                original: '/images/projects/11/004.jpg',
                thumbnail: '/images/projects/11/thumbnail/004.jpg',
            },
            {
                original: '/images/projects/11/005.jpg',
                thumbnail: '/images/projects/11/thumbnail/005.jpg',
            },
            {
                original: '/images/projects/11/006.jpg',
                thumbnail: '/images/projects/11/thumbnail/006.jpg',
            },
            {
                original: '/images/projects/11/007.jpg',
                thumbnail: '/images/projects/11/thumbnail/007.jpg',
            },
        ],
    },
];
